var _calculateRatio = function _calculateRatio(ratio) {
  var splitratio = ratio.split(':');
  return splitratio[1] / splitratio[0] * 100;
};
var ratios = {
  '1:1': 100,
  '1:2': 2 / 1 * 100,
  '2:1': 1 / 2 * 100,
  '2:2': 100,
  '2:3': 3 / 2 * 100,
  '3:1': 1 / 3 * 100,
  '3:2': 2 / 3 * 100,
  '3:4': 4 / 3 * 100,
  '4:1': 1 / 4 * 100,
  '4:2': 2 / 4 * 100,
  '4:3': 3 / 4 * 100,
  '4:7': 7 / 4 * 100,
  '4:9': 9 / 4 * 100,
  '5:4': 4 / 5 * 100,
  '5:6': 6 / 5 * 100,
  '5:7': 7 / 5 * 100,
  '7:3': 3 / 7 * 100,
  '8:3': 3 / 8 * 100,
  '9:2': 2 / 9 * 100,
  '9:4': 4 / 9 * 100,
  '9:16': 16 / 9 * 100,
  '16:9': 9 / 16 * 100
};
export { ratios };